import { useState } from "react";

function MasterWithPatternsModule() {
  const [activeModule, setActiveModule] = useState(null);

  const toggleModule = (index) => {
    setActiveModule(activeModule === index ? null : index);
  };

  const modules = [
    {
      title: "Module 1: Introduction to Trading Patterns",
      content: [
        "What are trading patterns and why they matter.",
        "Overview of chart analysis: candlesticks, price action, and volume.",
      ],
    },
    {
      title: "Module 2: Types of Chart Patterns",
      content: [
        "Key chart patterns: Head and Shoulders, Double Tops/Bottoms, Triangles, Flags, and Pennants.",
        "How these patterns signal potential market movements.",
      ],
    },
    {
      title: "Module 3: Support and Resistance Levels",
      content: [
        "Identifying key support and resistance levels.",
        "How patterns form around these levels and what they indicate.",
      ],
    },
    {
      title: "Module 4: Candlestick Patterns and their Importance",
      content: [
        "Key candlestick patterns: Doji, Engulfing, Hammer, and Shooting Star.",
        "Interpreting candlestick formations in conjunction with other patterns.",
      ],
    },
    {
      title: "Module 5: Trend Reversal Patterns",
      content: [
        "Patterns like Head and Shoulders and Double Tops/Bottoms.",
        "When and how to trade these reversal signals in Futures and Options.",
      ],
    },
    {
      title: "Module 6: Trend Continuation Patterns",
      content: [
        "Patterns like Triangles, Flags, and Pennants.",
        "Identifying continuation signals for entering trades aligned with the trend.",
      ],
    },
    {
      title: "Module 7: Breakout and Breakdown Patterns",
      content: [
        "How to identify breakouts from key patterns.",
        "Trading strategies for capturing large moves after breakouts or breakdowns.",
      ],
    },
    {
      title: "Module 8: Price Action and Volume Analysis",
      content: [
        "Understanding the relationship between price action and volume.",
        "Using volume to confirm patterns and improve trade accuracy.",
      ],
    },
    {
      title: "Module 9: Options Patterns and Greeks",
      content: [
        "How chart patterns affect Options pricing.",
        "Using the Greeks (Delta, Gamma, Theta, Vega) to enhance pattern-based strategies.",
      ],
    },
    {
      title: "Module 10: Futures Patterns and Leverage",
      content: [
        "Applying chart patterns to Futures trading.",
        "Managing leverage risk while trading Futures based on pattern setups.",
      ],
    },
    {
      title: "Module 11: Pattern Failures and Risk Management",
      content: [
        "Recognizing false signals and pattern breakdowns.",
        "How to mitigate risk with stop-loss orders and position sizing.",
      ],
    },
    {
      title: "Module 12: Combining Indicators with Patterns",
      content: [
        "How moving averages, RSI, MACD, and Bollinger Bands complement patterns.",
        "Using indicators to confirm or reject pattern signals.",
      ],
    },
    {
      title: "Module 13: Developing a Pattern-Based Trading Plan",
      content: [
        "Creating a trading strategy focused on pattern recognition.",
        "Incorporating risk management, trade setups, and exit strategies into the plan.",
      ],
    },
    {
      title: "Module 14: Psychology of Trading with Patterns",
      content: [
        "Overcoming emotional biases when patterns fail or mislead.",
        "Patience and discipline in waiting for the right patterns to form.",
      ],
    },
    {
      title: "Module 15: Mastering Patterns: Backtesting and Practice",
      content: [
        "How to backtest pattern-based strategies.",
        "Using demo accounts and historical data to refine pattern recognition skills.",
      ],
    },
  ];

  return (
    <div className="container py-5">
      <h1 className="text-center mb-5">Master with Patterns</h1>
      <div className="accordion">
        {modules.map((module, index) => (
          <div key={index} className="mb-3">
            <div
              className="p-3 bg-success text-white d-flex justify-content-between align-items-center"
              onClick={() => toggleModule(index)}
              style={{
                cursor: "pointer",
                borderRadius: "5px",
              }}
            >
              <h5 className="m-0">{module.title}</h5>
              <span
                style={{
                  fontSize: "18px",
                  transform: activeModule === index ? "rotate(180deg)" : "rotate(0deg)",
                  transition: "transform 0.3s ease",
                }}
              >
                ▼
              </span>
            </div>
            {activeModule === index && (
              <div
                className="p-3 bg-light border"
                style={{ borderRadius: "5px" }}
              >
                {module.content.map((item, i) => (
                  <p key={i} style={{ margin: "5px 0", fontSize: "14px" }}>
                    ➤ {item}
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default MasterWithPatternsModule;
